module.exports = __webpack_public_path__ + "static/qs-landing-c356c0115435685dd1d4d527c8dc1a69.png";